import {
  GridRenderCellParams,
  GridValueGetterParams,
} from "@mui/x-data-grid-pro";
import { Game, UpdateStatusParams } from "entities/game/types";
import Chip from "shared/components/Chip";
import DropdownList from "shared/components/DropdownList";
import FlexCenter from "shared/components/Layout/components/FlexCenter";
import { DrawerHookResult } from "shared/hooks/useDrawerState";
import { COLOR_PRIMARY_MAIN } from "shared/theme/colors";
import { ArrowForwardIcon } from "shared/theme/icons/ArrowForwardIcon";
import { formatUpdatedAt } from "shared/utils/formatUpdatedAt";
import { getChipColor, getTagsCount } from "./utils";

type ColumnsProps = {
  gameDetailsDrawer: DrawerHookResult<Game>;
  handleStatus: (values: UpdateStatusParams) => void;
  readOnly: boolean;
};

const renderStatusCell = (params: GridRenderCellParams) => {
  const color = getChipColor(params.value);
  const title = Boolean(params.value) ? "Active" : "Inactive";

  return <Chip title={title} bgColor={color} />;
};

export const getGamesColumns = ({
  gameDetailsDrawer,
  handleStatus,
  readOnly,
}: ColumnsProps) => {
  const renderActions = (game: Game) => {
    if (readOnly) {
      return (
        <FlexCenter onClick={() => gameDetailsDrawer.openDrawer(game)}>
          <ArrowForwardIcon color={COLOR_PRIMARY_MAIN} />
        </FlexCenter>
      );
    }

    const statusTitle = game.isActive ? "Deactivate" : "Activate";

    return (
      <DropdownList
        items={[
          {
            title: "Edit",
            onClick: () => {
              gameDetailsDrawer.openDrawer(game);
            },
          },
          {
            title: statusTitle,
            onClick: () => {
              handleStatus({
                gameId: game.id.toString(),
                status: !game.isActive,
              });
            },
          },
        ]}
      />
    );
  };

  return [
    {
      field: "externalId",
      headerName: "ID",
      editable: false,
      flex: 1,
      sortable: false,
    },
    {
      field: "displayName",
      headerName: "Game name",
      editable: false,
      flex: 1,
    },
    {
      field: "tags",
      headerName: "No. of tags",
      editable: false,
      flex: 1,
      align: "left",
      headerAlign: "left",
      sortable: false,
      renderCell: (params: GridValueGetterParams) => {
        return getTagsCount(params.row as Game);
      },
    },
    {
      field: "updatedAt",
      headerName: "Updated at",
      editable: false,
      flex: 1,
      headerAlign: "left",
      align: "left",
      renderCell: (params: GridValueGetterParams) =>
        formatUpdatedAt(params.value),
    },
    {
      field: "isActive",
      headerName: "Status",
      editable: false,
      align: "left",
      headerAlign: "left",
      flex: 0.5,
      renderCell: renderStatusCell,
    },
    {
      field: "actions",
      headerName: "",
      sortable: false,
      editable: false,
      align: "right",
      headerAlign: "right",
      flex: 0.5,
      renderCell: (params: GridValueGetterParams) => {
        return renderActions(params.row as Game);
      },
    },
  ];
};
